import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Panel } from 'primereact/panel'
import { TabPanel } from 'primereact/tabview'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  Cnpj,
  CustomCard,
  CustomTabView,
  ImportExcelFile,
  Loading,
  PageHeader,
  TextBtn,
} from '../../../../components'
import * as ImportacaoHttp from '../../../../services/api/https/deliveries/importation.http'
import ModalCliente from '../../Cadastros/Cliente/ModalCliente/ModalCliente'
import ModalProduto from '../../Cadastros/Produto/ModalProduto'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import './ImportacaoCicloEntrega.css'
import CardsResultadoImportacao from './CardsResultadoImportacao'
import TabsClientesEhProdutosNaoCadastrados from './TabsClientesEhProdutosNaoCadastrados'

class ImportacaoCicloEntrega extends Component {
  state = {
    isImporting: false,
    showBtnSalvar: false,
    showMode: 'message',
    produtosSemCadastros: [],
    produtosComInconsistencia: [],
    clientesSemCadastros: [],
    modalCliente: {
      show: false,
      data: null,
    },
    modalProduto: {
      show: false,
      data: null,
    },
    qteDeliveries: 0,
    qteIdentifiers: 0,
    qteSkus: 0,
    weight: 0,
  }

  // Events
  onBtnVoltar = () => {
    this.props.history.goBack()
  }

  onFileImported = async result => {
    try {
      // Remove the White Lines
      const resultFiltered = result.filter(r => r.length > 0)

      const {
        selectedCiclo: { cicloId, file_type_id },
      } = this.props

      // Prevent Error When User Refresh the page
      if (cicloId === null)
        throw new Error('Volte para a tela anterior e selecione o Ciclo de Entrega desejado')

      // Sending Information
      this.setState({ isImporting: true })
      const { qteDeliveries, qteIdentifiers, qteSkus, weight } =
        await ImportacaoHttp.importDeliveries(cicloId, resultFiltered, file_type_id)
      this.props.dispatch(showMessageBox('Importação realizada com sucesso', null))
      this.setState({
        isImporting: false,
        showMode: 'cards',
        qteDeliveries,
        qteIdentifiers,
        qteSkus,
        weight,
      })
    } catch (error) {
      const {
        message,
        clientsNotSaved = [],
        productsNotSaved = [],
        productsWithInconsistency = [],
      } = error
      if (message) {
        this.props.dispatch(showMessageBox(null, message, true))
        if (
          clientsNotSaved.length > 0 ||
          productsNotSaved.length > 0 ||
          productsWithInconsistency.length > 0
        ) {
          this.setState({
            produtosSemCadastros: productsNotSaved,
            produtosComInconsistencia: productsWithInconsistency,
            clientesSemCadastros: clientsNotSaved,
            isImporting: false,
            showMode: 'tabs',
          })
        }
      } else {
        this.props.dispatch(showMessageBox(null, error, true))
        this.setState({ isImporting: false })
      }
    }
  }

  onClienteRowClicked = cliente => {
    const { razao, fantasia, cnpj, code: company_code } = cliente
    const modalCliente = {
      show: true,
      data: {
        id: null,
        nomeFantasia: fantasia,
        razaoSocial: razao,
        cnpj,
        city_id: '',
        address: '',
        district: '',
        number: '',
        makeParcialReturn: false,
        actived: true,
        uf_id: '',
        company_code,
      },
    }
    this.setState({ modalCliente })
  }

  onProdutoRowClicked = produto => {
    const { code, name } = produto
    const {
      selectedCiclo: { empresaId, empresaDeId },
    } = this.props
    const modalProduto = {
      show: true,
      data: {
        id: null,
        product_code: code,
        company_id: empresaDeId || empresaId,
        name,
        weight: '',
        unit_sku: '',
        m3: '',
        actived: true,
      },
    }
    this.setState({ modalProduto })
  }

  onModalClose = modalName => {
    if (modalName === 'cliente') {
      const modalCliente = { show: false, data: null }
      this.setState({ modalCliente })
    }
    if (modalName === 'produto') {
      const modalProduto = { show: false, data: null }
      this.setState({ modalProduto })
    }
  }

  onModalSave = (modalName, info) => {
    if (modalName === 'cliente') {
      this.setState(state => {
        const { clientesSemCadastros } = state
        return {
          clientesSemCadastros: clientesSemCadastros.filter(c => c.code !== info.company_code),
          modalCliente: { show: false, data: null },
        }
      })
    }
    if (modalName === 'produto') {
      this.setState(state => {
        const { produtosSemCadastros } = state
        return {
          produtosSemCadastros: produtosSemCadastros.filter(c => c.code !== info.product_code),
          modalProduto: { show: false, data: null },
        }
      })
    }
  }

  async componentDidMount() {
    const {
      selectedCiclo: { cicloId },
    } = this.props
    if (cicloId && !Number.isNaN(cicloId)) {
      try {
        const { qteDeliveries, qteIdentifiers, qteSkus, weight } =
          await ImportacaoHttp.getCicloInfo(cicloId)
        if (qteDeliveries) {
          this.setState({ showMode: 'cards', qteDeliveries, qteIdentifiers, qteSkus, weight })
        } else {
          this.setState({ showMode: 'message' })
        }
      } catch (error) {
        this.props.dispatch(showMessageBox(null, error))
        this.setState({ showMode: 'message' })
      }
    }
  }
  // Render
  render() {
    const {
      showBtnSalvar,
      showMode,
      isImporting,
      modalCliente,
      modalProduto,
      qteDeliveries,
      qteIdentifiers,
      weight,
      qteSkus,
      produtosSemCadastros,
      produtosComInconsistencia,
      clientesSemCadastros,
    } = this.state

    /**
     * Tipo de Arquivo:52 Excel - Seara - Viagem
     * Neste modelo de planilha, as informações a serem importadas NÃO estão na primeira pasta
     * e sim na pasta "BASE - CARRINHOS"
     * Acredito que temos que adicionar na API, no ato do cadastro do tipo de arquivo EXCEL um
     * novo campo ABA para colocar o nome da aba OU o index ALVO
     */
    const abaName = [52, 61].includes(this.props.selectedCiclo.file_type_id)
      ? 'BASE - CARRINHO'
      : this.props.selectedCiclo.file_type_id === 88 // Tipo de arquivo 88 - Excel - PMG Secundário
        ? 'import'
        : this.props.selectedCiclo.file_type_id === 90 // Tipo de arquivo 90 - Excel - BRF
          ? 'ZAMI MCZ'
          : null
    const importarBtn = (
      <ImportExcelFile
        label="Importar"
        classes="btnImportar"
        onFileImported={this.onFileImported}
        abaName={abaName}
      />
    )
    const salvarBtn = (
      <Btn minWidth={null} onClick={() => {}}>
        Salvar
      </Btn>
    )
    const voltarBtn = <TextBtn onClick={this.onBtnVoltar}>Voltar</TextBtn>
    const panelHeader = (
      <div className="p-grid">
        <div className="p-col-3">
          {isImporting ? <Loading size="xs" /> : <span>{importarBtn}</span>}
          {showBtnSalvar ? salvarBtn : null}
          <div style={{ display: 'inline-block', marginLeft: 10 }}>{voltarBtn}</div>
        </div>
      </div>
    )
    return (
      <div className="ImportacaoCicloEntrega">
        <PageHeader>
          Importação&nbsp;<strong>EXCEL</strong>&nbsp;-&nbsp;Ciclos de Entrega&nbsp;-&nbsp;
          <strong>{this.props.selectedCiclo.cicloName}</strong>
        </PageHeader>
        <div style={{ marginTop: 20 }}>
          <Panel header={panelHeader}>
            {showMode === 'message' ? (
              <div style={{ textAlign: 'center', color: '#c4c4c4' }}>
                Para realizar a importação, clique no botão Importar
              </div>
            ) : null}
            {showMode === 'tabs' ? (
              <TabsClientesEhProdutosNaoCadastrados
                clientesSemCadastros={clientesSemCadastros}
                produtosSemCadastros={produtosSemCadastros}
                produtosComInconsistencia={produtosComInconsistencia}
              />
            ) : null}
            {showMode === 'cards' ? (
              <CardsResultadoImportacao
                qteDeliveries={qteDeliveries}
                qteIdentifiers={qteIdentifiers}
                qteSkus={qteSkus}
                weight={weight}
              />
            ) : null}
          </Panel>
        </div>
        {modalCliente.show ? (
          <ModalCliente
            data={modalCliente.data}
            show={modalCliente.show}
            onModalClose={() => this.onModalClose('cliente')}
            onModalSave={cliente => this.onModalSave('cliente', cliente)}
            associateWithSelectedCycle={true}
          />
        ) : null}
        {modalProduto.show ? (
          <ModalProduto
            data={modalProduto.data}
            show={modalProduto.show}
            onModalClose={() => this.onModalClose('produto')}
            onModalSave={produto => this.onModalSave('produto', produto)}
          />
        ) : null}
      </div>
    )
  }

  // Helpers
  _getTabsClientesEhProdutosNaoCadastrados = () => {
    const { produtosSemCadastros, clientesSemCadastros } = this.state
    const activeIndex = clientesSemCadastros.length === 0 ? 1 : 0
    return (
      <CustomTabView activeIndex={activeIndex}>
        <TabPanel header="Clientes Não Cadastrados" disabled={clientesSemCadastros.length === 0}>
          <DataTable
            selectionMode="single"
            onSelectionChange={e => this.onClienteRowClicked(e.value)}
            paginator={true}
            rows={10}
            value={clientesSemCadastros}
          >
            <Column field="code" header="Código" style={tableCellCentered()} />
            <Column field="razao" header="Razão Social" />
            <Column field="fantasia" header="Fantasia" />
            <Column
              field="cnpj"
              header="CNPJ"
              style={tableCellCentered(180)}
              body={cliente => <Cnpj>{cliente.cnpj}</Cnpj>}
              bodyStyle={tableCellCentered(180)}
            />
          </DataTable>
        </TabPanel>
        <TabPanel header="Produtos Não Cadastrados" disabled={produtosSemCadastros.length === 0}>
          <DataTable
            selectionMode="single"
            onSelectionChange={e => this.onProdutoRowClicked(e.value)}
            paginator={true}
            rows={10}
            value={produtosSemCadastros}
            className="auto-layout"
          >
            <Column field="code" header="Código" style={tableCellCentered(200)} />
            <Column field="name" header="Produto" />
          </DataTable>
        </TabPanel>
      </CustomTabView>
    )
  }

  _getCards = () => {
    const { qteDeliveries, qteIdentifiers, weight, qteSkus } = this.state
    const items = [
      { title: 'Qte de Entregas', value: qteDeliveries },
      { title: 'Qte de Identificadores', value: qteIdentifiers },
      { title: 'Peso Total', value: weight },
      { title: 'Qte Skus', value: qteSkus },
    ]
    const valueStyle = {
      fontSize: '1.2rem',
      color: '#14B0BF',
      fontWeight: 600,
    }
    return (
      <div className="p-grid">
        {items.map(i => (
          <div className="p-col-3" key={i.title}>
            <CustomCard valueStyle={valueStyle} title={i.title}>
              {i.value.toLocaleString()}
            </CustomCard>
          </div>
        ))}
      </div>
    )
  }
}

const mapStateToProps = ({ ciclo_entrega: { selectedCiclo } }) => ({ selectedCiclo })
export default connect(mapStateToProps)(withRouter(ImportacaoCicloEntrega))
